import React from "react";
import { Link } from "react-router-dom";

function AppsTable({ apps }) {
  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg mt-12">
      <table className="w-full text-sm text-left text-gray-500 ">
        <thead className="text-xs text-gray-700 uppercase bg-yellow-100 ">
          <tr>
            <th scope="col" className="px-6 py-3">
              Name
            </th>
            <th scope="col" className="px-6 py-3">
              type
            </th>
            <th scope="col" className="px-6 py-3">
              paybill/till
            </th>
            <th scope="col" className="px-6 py-3">
              account No
            </th>
            <th scope="col" className="px-6 py-3">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {apps.length < 1 ? (
            <tr className="bg-yellow-50 border-b hover:bg-yellow-50 ">
              <th
                scope="row"
                className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
              >
                No apps
              </th>
            </tr>
          ) : (
            apps.map((app) => (
              <tr
                className="bg-yellow-50 border-b hover:bg-yellow-50"
                key={app._id}
              >
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                >
                  {app.name}
                </th>
                <td className="px-6 py-4">{app.type}</td>
                <td className="px-6 py-4">
                  {app.type === "BANK" ? "-" : app.merchant}
                </td>
                <td className="px-6 py-4">
                  {app.account_number ? app.account_number : "-"}
                </td>
                <td className="flex items-center px-6 py-4 space-x-3">
                  <div className="flex md:order-2">
                    <Link to={`/app-dashboard/${app._id}`}>
                      <button className="inline-flex items-center  text-yellow-700 border-0 py-1 px-3 focus:outline-none md:hover:bg-yellow-100 rounded text-base mt-2 md:mt-0">
                        <h1 className="hidden md:block">Go To App</h1>
                        <svg
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          className="w-4 h-4 ml-1 text-yellow-700"
                          viewBox="0 0 24 24"
                        >
                          <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                      </button>
                    </Link>
                  </div>
                </td>
              </tr>
            ))
          )}
          {/* <tr className="bg-yellow-50 border-b hover:bg-yellow-50 ">
            <th
              scope="row"
              className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
            >
              Biashara Pro
            </th>
            <td className="px-6 py-4">PAYBILL</td>
            <td className="px-6 py-4">4012782</td>
            <td className="px-6 py-4">5632878738</td>

            <td className="flex items-center px-6 py-4 space-x-3">
              <div className="flex md:order-2">
                <Link to="/app-dashboard">
                  <button className="inline-flex items-center  text-yellow-700 border-0 py-1 px-3 focus:outline-none md:hover:bg-yellow-100 rounded text-base mt-2 md:mt-0">
                    <h1 className="hidden md:block">Go To App</h1>
                    <svg
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      className="w-4 h-4 ml-1 text-yellow-700"
                      viewBox="0 0 24 24"
                    >
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </button>
                </Link>
              </div>
            </td>
          </tr> */}
        </tbody>
      </table>
    </div>
  );
}

export default AppsTable;
